export default __webpack_public_path__ + "static/media/motocross.ba070f0b.jpg";